module.exports = __webpack_public_path__ + "static/quick-stay-founder-0080619b644492d068f545941b62a593.png";